/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AccessMutationResponse = {
  orgId: string;
  modelIds: Array<string>;
};

/** @internal */
export const AccessMutationResponse$inboundSchema: z.ZodType<
  AccessMutationResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  org_id: z.string(),
  model_ids: z.array(z.string()),
}).transform((v) => {
  return remap$(v, {
    "org_id": "orgId",
    "model_ids": "modelIds",
  });
});
/** @internal */
export type AccessMutationResponse$Outbound = {
  org_id: string;
  model_ids: Array<string>;
};

/** @internal */
export const AccessMutationResponse$outboundSchema: z.ZodType<
  AccessMutationResponse$Outbound,
  z.ZodTypeDef,
  AccessMutationResponse
> = z.object({
  orgId: z.string(),
  modelIds: z.array(z.string()),
}).transform((v) => {
  return remap$(v, {
    orgId: "org_id",
    modelIds: "model_ids",
  });
});

export function accessMutationResponseToJSON(
  accessMutationResponse: AccessMutationResponse,
): string {
  return JSON.stringify(
    AccessMutationResponse$outboundSchema.parse(accessMutationResponse),
  );
}
export function accessMutationResponseFromJSON(
  jsonString: string,
): SafeParseResult<AccessMutationResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AccessMutationResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AccessMutationResponse' from JSON`,
  );
}
